import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";

const useDebounce = ({ toDebounce }) => {
  const [debounced, setDebounced] = useState(toDebounce);

  // A stable debounced setter — created once via useMemo so the identity is fixed
  // across renders (avoids the react-hooks/exhaustive-deps "unknown dependencies"
  // warning that arises from wrapping lodash.debounce in useCallback).
  const updateDebounced = useMemo(
    () => debounce((newToDebounce) => setDebounced(newToDebounce), 600),
    []
  );

  useEffect(() => {
    updateDebounced(toDebounce);
  }, [toDebounce, updateDebounced]);

  // Cancel any pending invocation on unmount.
  useEffect(() => () => updateDebounced.cancel(), [updateDebounced]);

  return {
    debounced,
  };
};

export default useDebounce;
